import { HeaderToggle, OrderItem } from '@components';
import { Container, Typography } from '@design-system';
import React from 'react';
import './MyOrdersPage.scss';
import { MyOrdersSkeleton } from './MyOrdersSkeleton';
import { useMyOrdersPageVM } from './useMyOrdersPageVM';

export const MyOrdersPage: React.FC = () => {
    const { currentOrders, pastOrders, isLoading, errorMessage } = useMyOrdersPageVM();

    if (errorMessage) {
        return (
            <Container>
                <Typography intrinsic="p" color="red">
                    {errorMessage}
                </Typography>
            </Container>
        );
    }

    return (
        <div className="my-orders-page">
            <HeaderToggle labels={['En cours', 'Passées']}>
                {isLoading || !currentOrders ? (
                    <MyOrdersSkeleton />
                ) : (
                    <div>
                        {currentOrders.map((order) => (
                            <OrderItem key={order.id} {...order} />
                        ))}
                    </div>
                )}

                {isLoading ? (
                    <MyOrdersSkeleton />
                ) : (
                    <div>
                        {pastOrders.map((order) => (
                            <OrderItem key={order.id} {...order} isPast />
                        ))}
                    </div>
                )}
            </HeaderToggle>
        </div>
    );
};
